// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1hwJr","footer":"ModalFilter_footer__3AHul"};